<template>
    <v-icon :color="resolvedColor" :size="size">{{ resolvedIcon }}</v-icon>
</template>

<script setup lang="ts">
import { computed, defineProps } from 'vue';

// Mapování hodnot icon na MDI ikony
const iconMap: Record<string, string> = {
  'default': 'mdi-hockey-sticks',
  'hockey-puck': 'mdi-hockey-puck',
  'whistle': 'mdi-whistle',
  'run': 'mdi-run',
  'weight': 'mdi-weight-lifter',
  'camp': 'mdi-tent',
  'strategy': 'mdi-strategy',
  'video': 'mdi-video',
};

// Definice props
interface Props {
    type: string;
    icon?: string;
    size?: string;
}

const props = defineProps<Props>();

// Logika pro volbu ikony na základě typu nebo explicitní icon prop
const resolvedIcon = computed(() => {
    // Pokud je explicitně nastavena ikona (a není 'default'), použij ji
    if (props.icon && props.icon !== 'default' && iconMap[props.icon]) {
        return iconMap[props.icon];
    }
    
    // Fallback na type
    switch (props.type) {
        case 'training':
            return 'mdi-weight-lifter';
        case 'camp':
            return 'mdi-tent';
        case 'superliga':
            return 'mdi-medal';
        case 'friendly-match':
            return 'mdi-handshake';
        case 'blue-white':
            return 'mdi-hockey-sticks';
        case 'beer':
            return 'mdi-glass-mug-variant';
        default:
            return 'mdi-help'; // Výchozí ikona, pokud typ není rozpoznán
    }
});

// Logika pro volbu barvy na základě typu
const resolvedColor = computed(() => {
    switch (props.type) {
        case 'training':
            return 'red';
        case 'superliga':
            return 'mhgold';
        case 'friendly-match':
            return 'green';
        case 'blue-white':
            return 'blue';
        case 'beer':
            return 'orange';
        default:
            return 'red'; // Výchozí barva, pokud typ není rozpoznán
    }
});
</script>
